export const basicModules = [
  {
    label: '基本功能',
    value: '基本功能'
  },
]

export const basicTree = [
  {
    title: '基本功能',
    expand: true,
    code: 'basic',
    children: [
      {
        title: '用户管理',
        expand: true,
        code: 'userM',
        children: [
          {
            title: '用户管理配置',
            expand: true,
            code: 'userConfig',
            childrens: [
              {
                title: '查看',
                code: 'userConfig-look',
              }
            ]
          },
          {
            title: '组织管理',
            expand: true,
            code: 'organM',
            childrens: [
              {
                title: '查看',
                code: 'organM-look',
              },
              {
                title: '角色权限设置',
                code: 'organM-role',
              },
              {
                title: '添加部门',
                code: 'organM-addDep',
              },
              {
                title: '编辑部门',
                code: 'organM-putDep',
              },
              {
                title: '删除部门',
                code: 'organM-delDep',
              },
              {
                title: '添加账号',
                code: 'organM-addUser',
              },
              {
                title: '编辑账号',
                code: 'organM-putUser',
              },
              {
                title: '分享登录信息',
                code: 'organM-shareInfo',
              },
              {
                title: '重置密码',
                code: 'organM-resetPass',
              },
              {
                title: '启用/禁用账号',
                code: 'organM-putUserStatus',
              }
            ]
          },
          {
            title: '角色管理',
            expand: true,
            code: 'roleM',
            childrens: [
              {
                title: '查看',
                code: 'roleM-look',
              },
              {
                title: '添加',
                code: 'roleM-add',
              },
              {
                title: '编辑',
                code: 'roleM-edit',
              },
              {
                title: '删除',
                code: 'roleM-del',
              },
              {
                title: '设置账号',
                code: 'roleM-put',
              },
            ]
          },
          {
            title: '个人中心',
            expand: true,
            code: 'person',
            childrens: [
              {
                title: '查看',
                code: 'person-look',
              },
              {
                title: '修改用户名',
                code: 'person-editName',
              },
              {
                title: '修改密码',
                code: 'person-editPsw',
              },
              {
                title: '修改邮箱',
                code: 'person-editMail',
              },
            ]
          },
          {
            title: '导航菜单',
            expand: true,
            code: 'menu',
            childrens: [
              {
                title: '切换组织',
                code: 'organ-change',
              }
            ]
          }
        ]
      },
      {
        title: '主题配色',
        expand: true,
        code: 'colorsTheme',
        childrens: [
          {
            title: '查看',
            code: 'theme-look'
          },
          {
            title: '应用到全部账号',
            code: 'theme-useAll'
          }
        ]
      }
    ]
  },
]